// This module is responsible for communicating with the
// client library on the parent page

import Postie from 'postie'

const ClientLibraryComm = (widgetId) => {
  if (!widgetId) {
    console.warn('Credible Widget Error | No Widget ID provided')
    return null
  }

  const input = new Postie(null)
  const output = new Postie(window.parent)

  return {
    sendMessage: (message, ...messageArgs) => {
      output.post(`CredibleIframe [${widgetId}]: ${message}`, ...messageArgs)
    },
    listenOnce: (message, callback) => {
      input.once(`CredibleSDKCommunicator [${widgetId}]: ${message}`, callback)
    },
  }
}

export default ClientLibraryComm
